import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "../components/sideMenu/SideBar";
import { routes as appRoutes } from "../routes";
import FooterLogo from "../assets/icon/empTXP.png";
import { useDispatch, useSelector } from "react-redux";
import {
  pushNotification,
  setFilteredRoutes,
  setUserGroup,
  setUserId,
} from "../redux/actions";
import Notification from "../components/common/notification";
import { makeStyles } from "@mui/styles";
import { INITIAL_THEME } from "../theme";
import userIcon from "../assets/icon/man.png";
import { getMenu } from "../services/MenuService";
import Dashboard from "../screen/Dashboard";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PreLoader from "../components/common/preLoader";
import { Code } from "react-content-loader";
import { getRoles } from "../services/RoleService";
import { getUserPreferences } from "../services/UserService";
import Drawer from "@mui/material/Drawer";
import Profile from "./Profile";

const useStyles = makeStyles((theme) => ({
  wrapperContainer: {
    display: "flex",
    gap: 2,
    width: "100%",
  },
  notificationSnackbar: {
    // zIndex: 1000000,
  },
}));

const Wrapper = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { notification } = useSelector((state: any) => ({
    notification: state.notification,
  }));

  const [validRoutes, setValidRoutes] = React.useState<any>([]);

  const [openAnchor, setOpenAnchor] = useState(false);

  const handleClickOpenAnchor = () => {
    setOpenAnchor(true);
  };

  const handleClickCloseAnchor = () => {
    setOpenAnchor(false);
  };

  const [userInfo, setUserInfo] = React.useState<any>({});

  const getUserProfileImage = async () => {
    const response = await getUserPreferences();

    setUserInfo(response.data);
  };

  const closeNotification = () => {
    dispatch(
      pushNotification({
        ...notification,
        isOpen: false,
      })
    );
  };
  const [activeTab, setActiveTab] = React.useState(0);

  const logo = {
    title: `${sessionStorage.getItem("first-name")}  ${sessionStorage.getItem(
      "last-name"
    )}`,
    icon: `data:image/jpeg;base64,${userInfo.profilePicture}` || userIcon,
  };

  const tabStyles = {
    activeIconColor: INITIAL_THEME.palette.primary.main,
    activeIndicatorColor: INITIAL_THEME.palette.primary.main,
    scrollButtonColor: INITIAL_THEME.palette.primary.main,
    menusBackgroundColor: "#fff",
  };

  const handleLogoClick = (e) => {
    setOpenAnchor((prevState) => !prevState);
  };

  // const handleGetMenus = async () => {
  //   try {
  //     const response: any = await getMenu();
  //     if (response && response?.length > 0) {
  //       const routeKeys = response?.map((menu) => menu.url);
  //       const uniqueTitles = new Set();

  //       const filteredRoutes = appRoutes
  //         .filter((route) => routeKeys.includes(route.key))
  //         .filter(
  //           (route) =>
  //             !uniqueTitles.has(route.title) && uniqueTitles.add(route.title)
  //         );

  //       // Assign new indices to filteredRoutes based on its length
  //       const filteredRoutesWithNewIndices = filteredRoutes.map(
  //         (route, index) => ({
  //           ...route,
  //           index: index,
  //         })
  //       );

  //       setValidRoutes([...filteredRoutesWithNewIndices]);

  //       dispatch(setFilteredRoutes([...filteredRoutesWithNewIndices]));
  //     } else {
  //       setValidRoutes(validRoutes);
  //     }
  //   } catch (error) {
  //     // Handle the error if getMenu() fails
  //     console.error("Error fetching menu:", error);
  //   }
  // };

  const handleGetMenus = async () => {
    try {
      const response: any = await getMenu();
      if (response && response?.length > 0) {
        const routeKeys = response?.map((menu) => menu.url);
        const uniqueTitles = new Set();
        const filteredRoutes = appRoutes
          .filter((route) => routeKeys.includes(route.key))
          .filter(
            (route) =>
              !uniqueTitles.has(route.title) && uniqueTitles.add(route.title)
          )
          .map((route, index) => ({ ...route, index }));

        setValidRoutes(filteredRoutes);
        dispatch(setFilteredRoutes(filteredRoutes));
      } else {
        setValidRoutes([]);
        dispatch(setFilteredRoutes([]));
      }
    } catch (error) {
      console.error("Error fetching menu:", error);
    }
  };

  const handleGetGroups = async () => {
    const response = await getRoles();
    let filteredValues = response?.data?.groups.filter((str) =>
      str.startsWith("/insurpro")
    );
    dispatch(setUserGroup(filteredValues[0]));
    dispatch(setUserId(response?.data?.userId));
  };

  useEffect(() => {
    handleGetMenus();
    handleGetGroups();
    getUserProfileImage();
  }, []);

  return (
    <Box className={classes.wrapperContainer}>
      <Drawer
        anchor={"bottom"}
        open={openAnchor}
        onClose={handleClickCloseAnchor}
      >
        <Profile logo={logo} />
      </Drawer>

      <Box>
        {validRoutes?.length > 0 ? (
          <Sidebar
            tabs={validRoutes}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabStyles={tabStyles}
            logo={logo}
            handleLogoClick={handleLogoClick}
            footerLogo={FooterLogo}
          />
        ) : (
          <PreLoader />
        )}
      </Box>
      <Box width={"100%"}>{props.children}</Box>

      <Notification
        className={classes.notificationSnackbar}
        isOpen={notification.isOpen}
        type={notification.type}
        message={notification.message}
        handleClose={closeNotification}
      />
    </Box>
  );
};

export default Wrapper;
